export default __webpack_public_path__ + "static/media/Paused.a8ced0b2.svg";